import token from '@uipath/apollo-core/lib';
export const MuiIconButton = (palette) => ({
    root: {
        padding: token.Padding.PadL,
        '&&:hover': { backgroundColor: palette.semantic.colorIconButtonHover },
        '&.MuiIconButton-colorPrimary, &.MuiIconButton-colorSecondary': {
            '&&:hover': { backgroundColor: palette.semantic.colorHover },
            '&&:focus-visible': { backgroundColor: palette.semantic.colorHover },
            '&&:active': { backgroundColor: palette.semantic.colorSecondaryPressed },
        },
        '&.Mui-disabled': { color: palette.semantic.colorForegroundDisable },
    },
});
